<script setup lang="ts">
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps } from 'reka-ui'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-vue-next'
import type { HTMLAttributes } from 'vue'

const props = defineProps<AccordionTriggerProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
    <AccordionHeader class="flex flex-1">
        <AccordionTrigger
            v-bind="{ ...props, class: undefined }"
            :class="
                cn(
                    'flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline bg-background [&[data-state=open]>svg]:rotate-180',
                    props.class,
                )
            "
        >
            <slot />
            <ChevronDown class="size-4 shrink-0 text-muted-foreground transition-transform duration-200" />
        </AccordionTrigger>
    </AccordionHeader>
</template>
